export default {
  getCoordinates(place) {
    return new Promise(function (resolve, reject) {
      if (place !== undefined) {
        const handleGeocodeSuccess = function (location) {
          const lat = location.lat();
          const lng = location.lng();

          resolve([lat, lng]);
        };

        if (!place.geometry) {
          const options = {
            address: place.name
          };
          const handleOrAlert = function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              const { location } = results[0].geometry;

              handleGeocodeSuccess(location);
            } else {
              reject('The address you entered was not valid please try again');
            }
          };

          const geocoder = new google.maps.Geocoder();

          geocoder.geocode(options, handleOrAlert);
        } else {
          const { location } = place.geometry;

          handleGeocodeSuccess(location);
        }
      } else {
        reject('Invalid/missing place argument');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./client/utils/coordinates.js